import { SafetyOutlined, WarningOutlined } from "@ant-design/icons";
import { Button, Collapse, List } from "antd";
import React from "react";
import { AuthorisationIndicator } from "~/components/authorise/AuthorisationIndicator.jsx";
import { checkRecencyWarnings } from "~/components/recency/checkRecencyWarnings.js";
import { RecencyCurrencyBarometer } from "~/components/recency/RecencyCurrencyBarometer.jsx";
import { $t } from "~/i18n.js";
import { PilotAvatar } from "~/pages/ledenlijst/PilotAvatar.jsx";


export const RecencyWarnings = ({
  aanmeldingen,
  setOpenPilot,
  profile,
  enableAuthorization = false,
  canAuthorize = false,
  setAuthorizationAanmeldingen = (list) => {},
}) => {
  const vliegersWithWarnings = aanmeldingen.filter(
    (a) => a.aangemeld && a.vlieger && checkRecencyWarnings(a.vlieger),
  );
  if (vliegersWithWarnings.length === 0) return null;

  // Check which aanmeldingen in this group need authorization
  const unAuthorizedItems = vliegersWithWarnings.filter(
    (item) => item.aangemeld && !item.authorised,
  );

  return (
    <Collapse
      defaultActiveKey={["1"]}
      style={{ marginBottom: 16, maxWidth: 750 }}
      size="small"
      items={[{
        key: "1",
        label: (
          <div
            className="row"
            style={{ gap: 8, justifyContent: "space-between" }}
          >
            <span className="capitalize">
              <WarningOutlined style={{ color: "#faad14", marginRight: 8 }} />
              {$t("Recency Warnings")} ({vliegersWithWarnings.length})
            </span>

            {/* Bulk Authorization Button */}
            {canAuthorize && (
              <Button
                size="small"
                type="primary"
                disabled={unAuthorizedItems.length === 0}
                icon={<SafetyOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  setAuthorizationAanmeldingen(unAuthorizedItems);
                }}
                shape="circle"
              />
            )}
          </div>
        ),
        children: (
        <List
          size="small"
          dataSource={vliegersWithWarnings}
          renderItem={(item) => (
            <List.Item className="clickable">
              <List.Item.Meta
                avatar={
                  <div onClick={() => setOpenPilot(item.vlieger)}>
                    <PilotAvatar vlieger={item.vlieger} />
                  </div>
                }
                title={
                  <div>
                    <p onClick={() => setOpenPilot(item.vlieger)}>
                      {item.vlieger.name}
                    </p>
                    {enableAuthorization && (
                      <div style={{ fontWeight: 400 }}>
                        <AuthorisationIndicator
                          aanmelding={{ ...item, requires_authorisation: true }}
                          isUser={profile.id === item.vlieger.id}
                          canAuthorize={canAuthorize}
                          canRevoke={canAuthorize}
                          onAuthorize={setAuthorizationAanmeldingen}
                        />
                      </div>
                    )}
                  </div>
                }
              />

              <div
                style={{ width: 100 }}
                onClick={() => setOpenPilot(item.vlieger)}
              >
                <RecencyCurrencyBarometer pilot={item.vlieger} />
              </div>
            </List.Item>
          )}
        />
        ),
      }]}
    />
  );
};
